type BuildPromotionalUrlParams = {
	email: string;
	source: "modal" | "banner" | "icon";
	promotionId: string;
};

export const buildPromotionalUrl = ({ email, source, promotionId }: BuildPromotionalUrlParams): string => {
	const baseUrl = "https://www.performyard.com/performyard-ai";

	const params = new URLSearchParams({ email, source, promotionId });
	return `${baseUrl}?${params.toString()}`;
};
